<template>
  <div class="pro-content">
    <div class="mine-header">
      <div class="mine-header-user">
        <div class="mine-use-img">
          <img class="header-img" :src="headerimg" alt />
          <img class="real-img" :src="realImg" alt />
        </div>
        <div class="mine-user">
          <div class="check-log" v-if="showLogin" @click="login">点击登录</div>
          <div class="check-log" v-if="showName">{{userName}}</div>
          <div class="user-phone">{{phone}}</div>
          <img class="vip-img" :src="vipImg" />
        </div>
      </div>
      <img class="check-in" @click.prevent="signIn" src="@/assets/publicImg/daily-check-in.png" alt />
<!--      <div class="h-div">-->
<!--        <div class="h-div1" @click="onClick('/myScores')">-->
<!--          <div class="div-left">-->
<!--            <div class="num-div">-->
<!--              今日-->
<!--              <span class="num-span">+{{topData && topData.todayCommission}}</span>-->
<!--            </div>-->
<!--            <div class="v-div">{{topData && topData.balance}}</div>-->
<!--            <div class="la-div">我的积分</div>-->
<!--          </div>-->
<!--          <p class="line-p"></p>-->
<!--        </div>-->
<!--        <div class="h-div1" @click="onClick('/myOrder')">-->
<!--          <div class="div-left">-->
<!--            <div class="num-div">-->
<!--              今日-->
<!--              <span class="num-span">+{{topData && topData.todayOrderCount}}</span>-->
<!--            </div>-->
<!--            <div class="v-div">{{topData && topData.totalOrderCount}}</div>-->
<!--            <div class="la-div">我的订单</div>-->
<!--          </div>-->
<!--          <p class="line-p"></p>-->
<!--        </div>-->
<!--        <div class="h-div1" @click="onClick('/myClient')">-->
<!--          <div class="div-left">-->
<!--            <div class="num-div">-->
<!--              今日-->
<!--              <span class="num-span">+{{topData && topData.todayCus}}</span>-->
<!--            </div>-->
<!--            <div class="v-div">{{topData && topData.totalCus}}</div>-->
<!--            <div class="la-div">我的客户</div>-->
<!--          </div>-->
<!--          <p class="line-p"></p>-->
<!--        </div>-->
<!--        <div class="h-div1" @click="onClick('/browseHistory')">-->
<!--          <div class="div-left">-->
<!--            <div class="num-div">-->
<!--              今日-->
<!--              <span class="num-span">+{{topData && topData.todayTrace}}</span>-->
<!--            </div>-->
<!--            <div class="v-div">{{topData && topData.totalTrace}}</div>-->
<!--            <div class="la-div">访问量</div>-->
<!--          </div>-->
<!--          <p class="line-p"></p>-->
<!--        </div>-->
<!--      </div>-->
    </div>
<!--    <div class="top-div1">-->
<!--      <div class="div1-lef">-->
<!--        <div class="left-s">今日访客：{{topData && topData.todayPeople}}</div>-->
<!--        <div class="left-s">总访问量：{{topData && topData.totalPeople}}</div>-->
<!--        <div>-->
<!--          <van-button-->
<!--            @click="myShop"-->
<!--            color="linear-gradient(to bottom right, #FF8D3C, #E65C15)"-->
<!--          >管理我的小店</van-button>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="div1-rig">-->
<!--        <img @click="invite" src="@/assets/publicImg/mine-bg1.png" alt />-->
<!--        <img @click="card" src="@/assets/publicImg/mine-bg2.png" alt />-->
<!--      </div>-->
<!--    </div>-->
    <!-- 客户服务 -->
    <div class="customer-service">
      <div class="list-nav">常用工具</div>
      <div class="service-icon">
        <div class="promote-right-img" v-for="(item, index) in moduleList" :key="0+index">
          <div class="home-line" @click="checkUp(item)">
            <div id="qqq">
              <svg-icon :icon-class="item.img"></svg-icon>
              <p class="promote-right-span">{{item.name}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 其他服务 -->
    <div class="customer-service other-service">
      <div class="list-nav">其他服务</div>
      <div class="other-list">
        <van-cell
          :title="item.title"
          is-link
          v-for="(item, index) in orderData"
          :key="index"
          @click="check(item)"
        >
          <template #icon>
            <svg-icon :icon-class="item.icon"></svg-icon>
          </template>
        </van-cell>
      </div>
    </div>
    <!--  -->
    <!-- 获客指导 -->
    <Guide-page ref="mychild"></Guide-page>
  </div>
</template>
<script>
import { Dialog, Toast } from 'vant';
import { jspay, setSession, setLocal } from '@/utils/utils';
import URL from "@/api/api";
import URLTB from "@/api/apiTB";
import GuidePage from '../pop-up-guide/guide-page.vue';
export default {
  components: { GuidePage },
  data() {
    return {
      headerimg: require(`../../assets/publicImg/header.png`),
      realImg: require(`../../assets/publicImg/real-name.png`),
      vipImg: require(`../../assets/publicImg/vip.png`),
      userName: "",
      phone:'',
      isLogin: '',
      showName: false,
      showLogin: true,
      baseUrl: "https://dtfcloud.com/",
      topList: [
        { label: '我的积分', value: '1500', num: '20', path: '/myScores' },
        { label: '我的订单', value: '1500', num: '20', path: '/myOrder' },
        { label: '我的客户', value: '1500', num: '20', path: '/myClient' },
        { label: '访问量', value: '1500', num: '20', path: '/browseHistory' },
      ],
      moduleList: [
        {
          name: "缴费记录",
          img: "mine2-icon5",
          path: '/tobePaid'
        },
        // {
        //   name: "产品筛选",
        //   img: "mine2-icon",
        //   path: "/activity",
        // },
        // {
        //   name: "信贷方案",
        //   img: "mine2-icon1",
        //   path: "/activity",
        // },
        {
          name: "每日签到",
          img: "mine2-icon2",
          path: "/moreInviteType",
        },
        // {
        //   name: "计算器",
        //   img: "mine2-icon3",
        //   path: '/activity'
        // },
        {
          name: "我的文库",
          img: "mine2-icon4",
          path: "/uploadedList",
        },
        // {
        //   name: "活动记录",
        //   img: "mine2-icon5",
        //   path: '/activity'
        // },
        {
          name: "专属客服",
          img: "mine2-icon6",
        },
        {
          name: "业务咨询",
          img: "mine2-icon7",
          path: "/consult",
        },
        {
          name: "投诉建议",
          img: "mine2-icon8",
          path: "/suggestions",
        },
        // {
        //   name: "获客指导",
        //   img: "mine2-icon9",
        //   path: "/activity",
        // },
      ],
      orderData: [
        {
          title: "个人信息",
          icon: 'mine2-other1',
          path: "/personalInfo",
        },
        // {
        //   title: "账户与安全",
        //   icon: 'mine2-other2',
        //   path: "/accountSecurity",
        // },
        {
          title: "实名认证",
          icon: 'mine2-other3',
          path: "/identityCheck",
        },
        // {
        //   title: "银行卡授权",
        //   icon: 'mine2-other4',
        //   path: '/bankCard/details'
        // },
        {
          title: "隐私协议",
          icon: 'mine2-other5',
          path: "/privacy",
        },
        {
          title: "服务使用协议",
          icon: 'mine2-other5',
          path: "/userTxt",
        },
        {
          title: "关于我们",
          icon: 'mine2-other5',
          path: "/aboutUs",
        },
      ],
      withdrawal: '',
      topData: {}//数据渲染
    };
  },
  mounted() {
    if (location.hostname === "zf.dtfcloud.com") {
      this.baseUrl = "https://zf.dtfcloud.com/";

    } else {
      this.baseUrl = "http://jzt.dtfcloud.com/";

    }
    this.checkOpenid()
    this.getmineData()
  },
  methods: {
    // top 数据获取
    getmineData() {
      let data = {
        userId: localStorage.getItem('userid'),
        agentPhone: localStorage.getItem('phone')
      }
      this.$fetchGet(URLTB.getMineData.url, data).then(res => {
        this.topData = res.data.data;
      })
    },
    //每日签到
    signIn(){
      this.$router.push('/moreInviteType')
    },
    // 邀请好友
    invite() {
      this.$router.push('/inviteFriends')
    },
    // 分享名片
    card() {
      this.$router.push('/businessCard')
    },
    onClick(item) {
      this.$router.push(item)
    },
    // 我的小店
    myShop() {
      this.$router.push('/littleShop')
    },
    checkOpenid() {
      let that = this
      let openid = localStorage.getItem("openid");
      that.$fetchPost(URL.checkOpenid.url + openid).then((res) => {
        if (res.data.code === 20000) {
          setLocal("isLogin", 1);
          setLocal("phone", res.data.data.phoneNo);
          setLocal("authFlag", res.data.data.authFlag);
          setLocal("buyFlag", res.data.data.buyFlag);
          setLocal("showName", res.data.data.showName);
          setLocal("showPhone", res.data.data.showPhone);
          setSession("user_tel", res.data.data.phoneNo);
          setSession("phoneNumber", res.data.data.phoneNo);
          setSession("phone", res.data.data.phoneNo);
          setLocal("cip", res.data.data.ip);
          if (res.data.data.authFlag === '1') {
            that.realImg = require(`../../assets/publicImg/real-name1.png`)
          }
          if (res.data.data.nickName && localStorage.getItem("isLogin") == 1) {
            this.showLogin = false
            this.showName = true
            this.phone=res.data.data.phoneNo
            this.userName = res.data.data.realName ? res.data.data.realName : res.data.data.nickName
            this.headerimg = res.data.data.headImg || require(`../../assets/publicImg/header.png`)
          }
        }
      });
    },
    check(item) {
      this.$router.push(item?.path);
      // if (item.title == "邀请好友") {

      //   window.location.href = "https://dtfcloud.com/post/index.html?flag=1";
      // }


    },
    getUrlParams: function (paramsName) {
      const url = window.location.href; //当前页面的地址
      const reg = /([^?&=]+)=([^?&=]+)/g,
        obj = {};
      url.replace(reg, function () {
        obj[arguments[1]] = arguments[2];
      });
      for (let keyName in obj) {
        if (keyName === paramsName) {
          return obj[keyName];
        }
      }

    },
    checkUp(item) {
      var authFlag = localStorage.getItem('authFlag') || null
      var buyFlag = localStorage.getItem('buyFlag') || null
      if (localStorage.getItem("isLogin") == '1') {
        // alert("11111111111111111")
        if (item.vlue == "个人名片") {
          if (authFlag == '0') {
            // Toast('未实名认证')
            Dialog.alert({
              message: '请前往，我的->个人中心->其他服务，下进行实名认证',
            }).then(() => {
              // on close
            });
          } else {
            this.$router.push(item.path);
          }
          // else if (buyFlag == '0') {
          //   Dialog.alert({
          //     message: '没有权限，请先购买会员',
          //   }).then(() => {
          //     // on close
          //     if (localStorage.getItem("buyFlag") == 1) {
          //       Toast('您已购买，请勿重复购买')
          //       return
          //     }
          //     // let data = this.commonUrl.LONE_URL + 'nameCard'
          //     let data = process.env.VUE_APP_LOAN_URL + 'nameCard'
          //     jspay(data)
          //   });
          // }
        } else if (item.name == "专属客服") {
          window.location.href = "https://work.weixin.qq.com/kfid/kfca7cf41da33800731";
        } else if (item.name == "获客指导") {
          this.$refs.mychild.getPop('true')
        } else {
          this.$router.push(item.path);
        }
      } else {
        this.$router.push({ path: '/login', query: { isLogin: 1 } })
      }
    },
    orderList() {
      this.$router.push("/orderList/details");
    },
    requireList() {
      //   this.$router.push("/requireList/details");
    },
    login() {
      this.$router.push({ path: '/login', query: { isLogin: 1 } })
    }
  },
};
</script>
<style lang="less" scoped>
.pro-content {
  height: 100vh;
  background: #fff;
  overflow: scroll;
  font-family: Source Han Sans CN;
  .mine-header {
    width: 375px;
    height: 153px;
    background: url("./img/bg.png") no-repeat 100%;
    background-size: 100% 100%;
    position: relative;
    .mine-header-user {
      width: 355px;
      margin: auto;
      display: flex;
      // justify-content: space-between;
      .mine-use-img {
        width: 65px;
        height: 62px;
        margin-top: 13px;
        position: relative;
        .header-img {
          width: 60px;
          height: 60px;
          border-radius: 50%;
        }
        .real-img {
          width: 35px;
          height: 13px;
          position: absolute;
          bottom: -7px;
          left: 13px;
        }
      }
      .mine-user {
        min-width: 87.5px;
        margin-left: 10px;
        color: #333333;
        .check-log {
          height: 14px;
          line-height: 14px;
          margin-top: 29px;
          font-size: 14px;
          font-weight: 500;
        }
        .user-phone {
          height: 9px;
          line-height: 9px;
          margin-top: 8px;
          font-size: 9px;
          font-weight: 400;
        }
        .vip-img {
          width: 62px;
          height: 15px;
        }
      }
    }
    .check-in {
      width: 70px;
      height: 25px;
      position: absolute;
      top: 19px;
      right: 11px;
    }
    .h-div {
      width: 355px;
      height: 80px;
      display: flex;
      margin: 15px auto auto;
      background: url("../../assets/publicImg/con-bg1.png") no-repeat 50%;
      background-size: 100% 100%;
      .h-div1 {
        display: flex;
        align-items: center;
        text-align: center;
        color: #666666;
        font-weight: 400;
        .div-left {
          width: 89px;
        }
        .num-div {
          text-align: right;
          padding-right: 11px;
          font-size: 6px;
          .num-span {
            color: #fc6c21;
          }
        }
        .v-div {
          font-size: 16px;
          font-weight: bold;
          color: #333333;
        }
        .la-div {
          font-size: 11px;
        }
        .line-p {
          width: 1px;
          height: 30px;
          background: #ededed;
        }
      }
    }
  }
  .top-div1 {
    width: 355px;
    height: 90px;
    margin: 51px auto auto;
    display: flex;
    justify-content: space-between;
    .div1-lef {
      width: 156px;
      height: 90px;
      background: url("../../assets/publicImg/mine-bg.png") no-repeat 50%;
      background-size: 100% 100%;
      font-size: 12px;
      font-weight: 500;
      color: #8b2f00;
      .left-s {
        margin-left: 26px;
        &:first-child {
          margin: 16px 0 3px 26px;
        }
      }
      .van-button {
        width: 108px;
        height: 20px;
        margin: 10px 0 0 24px;
        font-size: 11px;
      }
    }
    .div1-rig {
      width: 175px;
      img {
        width: 175px;
        height: 40px;
        &:last-child {
          margin-top: 4px;
        }
      }
    }
  }
  .customer-service {
    width: 355px;
    height: 204px;
    margin: 10px auto 0 auto;
    background: url("../../assets/publicImg/con-bg2.png") no-repeat 100%;
    background-size: 100% 100%;
    .list-nav {
      padding-left: 10px;
      font-size: 15px;
      font-weight: bold;
      color: #000000;
      height: 40px;
      line-height: 40px;
      background-color: rgba(255, 227, 208, 0.16);
    }
    .service-icon {
      // width: 100%;
      height: 77px;
      padding-left: 16.5px;
      display: flex;
      flex-wrap: wrap;
      text-align: center;
      align-items: center;
      font-weight: Regular;
      color: #666666;
      .promote-right-img {
        .svg-icon {
          width: 30px;
          height: 30px;
        }
      }
      .home-line {
        width: 64.5px;
        height: 50.5px;
        margin-top: 18px;
        display: flex;
        justify-content: center;
        position: relative;
      }
      .promote-right-span {
        // padding-top: 5px;
        font-size: 10px;
      }
    }
  }
  .other-service {
    width: 355px;
    height: 345px;
    margin: 10px auto 21px auto;
    background: url("../../assets/publicImg/con-bg2.png") no-repeat 100%;
    background-size: 100% 100%;
    .other-list {
      .svg-icon {
        width: 25px;
        height: 25px;
        padding-right: 12px;
      }
    }
    .van-cell {
      height: 50px;
      align-items: center;
      background: transparent;
      padding: 0 10px 0 10px;
    }
    .van-cell__left-icon {
      width: 18.02px;
      height: 19.53px;
    }
    .van-cell__title {
      font-size: 10.5px;
      color: #333333;
      font-weight: Regular;
    }
  }
}
</style>
